import axios from 'axios';

/**
 * Envía el trámite con sus archivos adjuntos al backend.
 * @param {FormData} formData - Payload multipart con campos y archivos
 * @returns {Promise<Object>} Respuesta del servidor
 */
export const submitTramite = async (formData) => {
  try {
    const response = await axios.post('v1/autorizaciones/agregar-documentacion-autorizacion', formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    const message = error.response?.data?.error;
    throw new Error(message || error.message || 'Error al enviar el trámite');
  }
};
